<template>
  <div class="orderinfo">
       <div class="order-bar">
              <div @click="barChange(0)" :class="{'select-bar':bar_index==0}">优惠订单</div>
              <div @click="barChange(1)" :class="{'select-bar':bar_index==1}">普通订单</div>
       </div>
       <div class="order-content" v-if="bar_index==0">
              <div class="dis-content">
                     <div class="dis-content-bar">
                            <div style="width:40px">序号</div>
                            <div>名称</div>
                            <div>优惠码</div>
                            <div>使用情况</div>
                            <!-- <div>使用人</div> -->
                            <div>创建时间</div>
                            <div>使用时间</div>
                            <div style="width:40px">分享</div>
                     </div>
                     <div class="dis-container">
                            <ul>
                                   <li v-for="(item, i) in dis_list" :key="i">
                                          <div style="width:40px">{{i+1}}</div>
                                          <div>{{item.vname}}</div>
                                          <div>{{item.dcode}}</div>
                                          <div>{{item.isuse == 0 ? '未使用' : '已使用'}}</div>
                                          <!-- <div>无</div> -->
                                          <div>{{item.createtime}}</div>
                                          <div>{{item.usetime? item.usetime : '无'}}</div>
                                          <div style="width:40px" @click="copy_code(item)">复制</div>
                                   </li>
                            </ul>
                     </div>
              </div>
              <div class="load-more" @click="dis_more" v-if="is_show_load_text">点击加载更多...</div>
       </div>
       <div class="order-user" v-else>
             <div class="order-user-bar">
                     <RadioGroup v-model="checked" direction="horizontal">
                            <Radio name="0" @click='radioClick(0)'>全部</Radio>
                            <Radio name="1" @click='radioClick(1)'>未支付</Radio>
                            <Radio name="2" @click='radioClick(2)'>已支付</Radio>
                     </RadioGroup>
             </div>
             <div class="order-user-container">
                     <div class="order-user-container-bar">
                            <div style="width:40px">序号</div>
                            <div>视频名称</div>
                            <div>订单号</div>
                            <!-- <div>用户</div> -->
                            <div>创建时间</div>
                            <div>支付时间</div>
                            <div>订单金额</div>
                            <div>订单状态</div>
                     </div>
                     <div class="order-user-list">
                            <ul>
                                   <li v-for="(item, i) in user_list" :key="i">
                                          <div style="width:40px">{{i+1}}</div>
                                          <div>{{item.vid}}</div>
                                          <div>{{item.ocode}}</div>
                                          <!-- <div>{{item.uname}}</div> -->
                                          <div>{{item.createtime}}</div>
                                          <div>{{item.paytime}}</div>
                                          <div>{{item.oprice}}</div>
                                          <div>{{item.isok == 0 ? '未支付' : '已支付'}}</div>
                                   </li>
                            </ul>
                     </div>
             </div>
       </div>
  </div>
</template>
<script setup>
import { getDisOrder, create_order, get_user_order } from '@/api/index'
import { computed, getCurrentInstance, onMounted,  ref, onBeforeMount} from "vue";
import { Form, Field, CellGroup, Icon, Popup, Picker, showLoadingToast, closeToast, showToast, RadioGroup, Radio } from 'vant';
import { set } from '@vueuse/core';
import { copyText } from '@/utils/global'
const bar_index = ref(0)
const limit_index = ref(1) //普通订单分页码
const limit_dis_index = ref(1) //优惠订单分页码
const limit_user_index = ref(1) //优惠订单分页码
const is_show_load_text = ref(true)
const dis_list = ref([])
const user_list = ref([])
const checked = ref('0');

onMounted(async () => {
       await get_dis_order()
       closeToast() 
})
// 优惠订单分页查询
const get_dis_order = async () => {
        showLoadingToast({
              message: "加载中...",
              duration: 0
       });
       let res = await getDisOrder({limit:limit_dis_index.value})
       if(res.data.length>0){
              let arr = dis_list.value
              for(let i = 0; i < res.data.length; i++){
              arr.push(res.data[i])  
              }
              dis_list.value = arr
              if(res.data.length == 0 ){
                     is_show_load_text.value = false
                     return
              }
              if(res.data.length % 2 == 0){
                     limit_dis_index.value += 1
              }else{
                     is_show_load_text.value = false
              }
       }
       setTimeout(() => {
             closeToast() 
       }, 500);
}
// 订单分页查询
const get_uer_order = async (e) => {
       showLoadingToast({
              message: "加载中...",
              duration: 0
       });
       let data = {limit:limit_user_index.value}
       if(e>=0){
           data.isok = e   
       }

       console.log(e )

       let res = await get_user_order(data)
       if(res.data.length>0){
              let arr = user_list.value
              for(let i = 0; i < res.data.length; i++){
              arr.push(res.data[i])  
              }
              user_list.value = arr
              if(res.data.length == 0 ){
                     is_show_load_text.value = false
                     return
              }
              if(res.data.length % 2 == 0){
                     limit_user_index.value += 1
              }else{
                     is_show_load_text.value = false
              }
       }
       setTimeout(() => {
             closeToast() 
       }, 500);
}
const radioClick = (e) => {
       user_list.value = []
       limit_user_index.value = 1
       if(parseInt(e)>0){
              console.log(parseInt(e)-1)
              get_uer_order(parseInt(e)-1)
       }else{
              get_uer_order(parseInt(e))
       }
       // console.log(e)
}
// 订单切换
const barChange =async (e) => {
       bar_index.value = e
       limit_dis_index.value = 1
       limit_user_index.value = 1
       user_list.value = []
       dis_list.value = []
       if(e==1){
              get_uer_order()
       }else{
              get_dis_order()
       }
}
// 优惠订单加载更多
const dis_more = () =>{
       get_dis_order()
}
// 复制优惠码
const copy_code = (e) => {
       let { vname, dcode, isuse } = e
       if(isuse == 1){
              showToast('该分享码使用')
              return
       }
       copyText(vname,dcode)
}
</script>
<style lang="less" scoped>
       .order-bar{
              font-size: 15px;
              display: flex;
              >div{
                     margin-left: 22px;
                     padding: 5px 10px;
                     border-radius: 8px;
                     cursor: pointer;
                     border: 1px solid rgba(22, 22, 245, 0.3);
                     box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),-5px -5px 10px rgba(0, 0, 0, 0.1);
              }
              .select-bar{
                     border-color:transparent;
                     color: #FFF;
                     background: rgba(22, 22, 245, 0.3);
              }
       }
       .order-content{
              width: 90%;
              height: calc(100vh - 200px);
              margin: 0 auto;
              position: relative;
              padding: 15px;
              .load-more{
                     position: absolute;
                     bottom: 15px;
                     left: 50%;
                     transform: translateX(-50%);
                     font-size: 10px;
                     cursor: pointer;
                     color: rgba(22, 22, 245, 0.3);
              }
       }
       .dis-content{
              .dis-content-bar{
                     display: flex;
                     justify-content: space-between;
                     font-size: 17px;
                     font-weight: bold;
                     >div{
                            width: calc(100% / 6);
                            text-align: center;
                     }
              }
       }
       .dis-container{
              height: calc(100vh - 240px);
              overflow: auto;
              li{
                     display: flex;
                     align-items: center;
                     font-size: 14px;
                     justify-content: space-between;
                     >div{
                            width: calc(100% / 6);
                            text-align: center;
                            margin-top: 12px;
                            white-space: nowrap;
                     }
                     >div:last-of-type{
                            cursor: pointer;
                            color: blue;
                            text-decoration: underline; 
                     }
              }
       }
       .order-user{ 
              width: 90%;
              height: calc(100vh - 200px);
              margin: 0 auto;
              position: relative;
              padding: 15px;
              .order-user-bar{
                     position: absolute;
                     left: -10%;
                     transform: scale(0.5);
                     height: 35px;
                     font-size: 18px;
              }
              .order-user-container-bar{ 
                     display: flex;
                     justify-content: space-between;
                     font-size: 17px;
                     font-weight: bold;
                     margin-top: 25px;
                     >div{
                            width: calc(100% / 7);
                            text-align: center;
                     }
                     >div:nth-of-type(3){
                            min-width: 200px;
                     }
              }
              .order-user-list{
                     li{
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            justify-content: space-between;
                            div{
                                   width: calc(100% / 7);
                                   text-align: center;
                                   white-space: nowrap;
                            }
                            >div:nth-of-type(3){
                                   min-width: 200px;
                            }
                     }
              }
       }
       
</style>